export const POLICY_STATUS = {
	LOCKED_7D: 'locked_7d',
	NONE: 'none'
}

export const LOCK_STATE = {
	ACTIVE: 'active',
	LOCKED: 'locked'
}
